import { render } from "./BookViewGoogleFaq.vue?vue&type=template&id=772d7894"
import script from "./BookViewGoogleFaq.vue?vue&type=script&lang=js"
export * from "./BookViewGoogleFaq.vue?vue&type=script&lang=js"
script.render = render

export default script